import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=08cc8338&"
import script from "./Error403.vue?vue&type=script&lang=js&"
export * from "./Error403.vue?vue&type=script&lang=js&"
import style0 from "./Error403.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports